import React from 'react';
import { FieldErrors, UseFormReturn } from 'react-hook-form';
import { HealtheraButton } from '../../../../healtheraComponents';
import { ClinicMasterProduct } from '../../../../apis/clinic-master-products/types';
import { enqueueSnackbar } from 'notistack';
import { useUpdateClinicProducts } from '../../../../apis/clinic-products/hooks/useUpdateClinicProducts';
import { ClinicProduct } from '../../../../apis/clinic-products/types';
import { useRemoveClinicProductsCache } from '../../../../apis/clinic-products/hooks/useClinicProducts';
import { useUpdateClinicMasterProduct } from '../../../../apis/clinic-master-products/hooks/useUpdateClinicMasterProduct';

interface Props {
  id: string;
  form: UseFormReturn<ClinicMasterProduct>;
  productsForm: UseFormReturn<ClinicProduct[]>;
}

const SaveClinicMasterProduct = ({ id, form, productsForm }: Props) => {
  const { updateClinicMasterProduct } = useUpdateClinicMasterProduct();
  const { updateClinicProducts, isLoading } = useUpdateClinicProducts();
  const removeProductsCache = useRemoveClinicProductsCache();

  function handleSave() {
    productsForm.handleSubmit(handleSaveProducts, handleInvalidForm)();
    form.handleSubmit(handleSaveMasterProduct, handleInvalidForm)();
  }

  async function handleSaveMasterProduct(masterProduct: ClinicMasterProduct) {
    if (masterProduct._id) {
      await updateClinicMasterProduct(masterProduct._id, masterProduct);
      enqueueSnackbar('Clinic master product updated', { variant: 'success' });
    }
  }

  async function handleSaveProducts(clinicProducts: ClinicProduct[]) {
    const clinicId = form.getValues('clinic_id');
    await updateClinicProducts(clinicProducts, clinicId);
    removeProductsCache(id);
    enqueueSnackbar('Clinic master product updated', { variant: 'success' });
  }

  function handleInvalidForm(_: FieldErrors<ClinicMasterProduct>) {
    enqueueSnackbar('Please fill in all required fields', { variant: 'error' });
  }

  return (
    <HealtheraButton disabled={isLoading} onClick={handleSave}>
      Save
    </HealtheraButton>
  );
};

export default SaveClinicMasterProduct;
